module.exports = __webpack_public_path__ + "static/media/telescope.43642920.svg";